/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';

// Material ui
import { makeStyles } from '@material-ui/core/styles';
import {
  Button, CircularProgress, Box, Typography, Grid, AppBar,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import { Img } from 'react-image';
import { uniqueId, isEmpty } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import 'moment/locale/th';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

// Icons
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

// Lightbox
import Lightbox from 'react-image-lightbox';
import Modal from '../../../../../components/modal/Modal';
import 'react-image-lightbox/style.css';

// Styles
import { styles, StyledTabs, StyledTab } from '../style';
import '../styles.css';

// svg
import Amphoe from '../../../../../assets/svg/amphoe.svg';
import ProvinceSVG from '../../../../../assets/svg/province';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const classes = useStyles();
  const {
    children, value, index, ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.contentImg}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `forecast_rain_modal_tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

export default function ForecastRainfallDataLists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const hostApi = `${process.env.REACT_APP_API_URL}`;

  // Loading Errors
  const [isLoading, setLoading] = useState(false);
  const [hasError, sethasError] = useState(false);

  // Data
  const [rain, setRain] = useState([{}, {}, {}]);
  const [rainsea, setRainsea] = useState([{}, {}, {}, {}, {}, {}, {}]);
  const [rainasia, setRainasia] = useState([{}, {}, {}, {}, {}, {}, {}]);
  const [rainbasin, setRainbasin] = useState([{}, {}, {}]);
  const [tmdrain, setTmdrain] = useState([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
  const placeHolder = 'https://via.placeholder.com/322x230?text=No%20Image&italic=true';

  // Index and handlers
  const [value, setValue] = useState(0);
  const [isOpen, setisOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lightIndex, setlightIndex] = useState();
  const [selectedImage, setSelectedImage] = useState(0);

  // https://hpc.tmd.go.th/static/images/idv/2021080312/d01/preci24hr/202108050000Z_Rain%20Daily.png
  const tmdLink = 'https://hpc.tmd.go.th/static/imgDA';

  useEffect(() => {
    function getData() {
      setLoading(true);
      fetch(`${hostApi}/public/rain7day_forecast`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          setRain([...data.data.pre_rain.data]);
          setRainsea([...data.data.pre_rain_sea.data]);
          setRainasia([...data.data.pre_rain_asia.data]);
          setRainbasin([...data.data.pre_rain_basin.data]);
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    getData();

    // ภาพ WRF จาก TMD เงื่อนไขการแสดงผล
    // 3 วันแรก เป็น domain 2 / วันที่ 4 -7  เป็น domain 1
    // เวลา 19.00-06.00น. ใช้ข้อมูล 00UTC
    // เวลา 07.00-18.00น.  ใข้ข้อมูล 12UTC
    // รายละเอียดติดต่อเบส นน.

    const temptmdrain = [];
    let domain = 'd01';
    const currentDate = moment();
    const currentHour = moment().format('H');
    let folderHour = '_0000';
    let firstDate = moment(currentDate);
    let dateForFolder = currentDate.format('YYYYMMDD');
    if (currentHour >= 7 && currentHour <= 18) {
      folderHour = '_1200';
      firstDate = moment(currentDate).format('YYYY-MM-DD');
      dateForFolder = moment(currentDate).subtract(1, 'days').format('YYYYMMDD');
    }
    const folderDate = `${dateForFolder}${folderHour}`;
    let tmdDate = '';

    for (let index = 0; index < 7; index += 1) {
      tmdDate = moment(new Date(firstDate)).add((index), 'days').format('YYYYMMDD');

      // if (index < 3) {
      //   domain = 'd02';
      // } else {
      //   domain = 'd01';
      // }
      temptmdrain.push(`${tmdLink}/${folderDate}/${domain}/p24h/p24h.${tmdDate}0000.${domain}.png`);
    }
    setTmdrain(temptmdrain);
  }, [hostApi]);

  function handleModalClose() {
    setIsModalOpen(false);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item>
            <Typography className={classes.titleSub}>
              {t('แผนภาพคาดการณ์ฝนล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองสภาพอากาศ WRF-ROMS Model โดย สสน.')}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          {rain.slice(0, 3).map((img, i) => {
            let toshow = '';
            if (img.media_path === undefined || img.media_path === '') {
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleBox}>{t('ไม่มีข้อมูล')}</Box>
                  <Box className={classes.bodyBox}><Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} /></Box>
                </Box>
              );
            } else {
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleBox}>{moment(img.media_datetime).format('ll')}</Box>
                  <Box className={classes.bodyBox}>
                    <Button
                      id={`forecast_rain_${i}`}
                      onClick={() => {
                        setIsModalOpen(true);
                        setSelectedImage(i);
                        // set which tab is selected
                        setValue(0);
                      }}
                    >
                      <Img
                        src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`}
                        alt={img.media_datetime}
                        className={classes.img}
                        unloader={(
                          <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                        )}
                      />
                    </Button>
                  </Box>
                </Box>
              );
            }
            return (
              <Grid item sm={4} md={4} key={uniqueId()}>
                {toshow}
              </Grid>
            );
          })}
        </Grid>
        <Grid container spacing={3} justifyContent="space-around">
          {rainsea.slice(3, 7).map((img, i) => {
            let toshow = '';
            if (img.media_path === undefined || img.media_path === '') {
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleSecondBox}>{t('ไม่มีข้อมูล')}</Box>
                  <Box className={classes.bodyBox}><Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} /></Box>
                </Box>
              );
            } else {
              toshow = (
                <Box display="block" mt={2}>
                  <Box className={classes.titleSecondBox}>{moment(img.media_datetime).format('ll')}</Box>
                  <Box className={classes.bodyBox}>
                    <Button
                      id={`forecast_rain_${i + 4}`}
                      onClick={() => {
                        setIsModalOpen(true);
                        setSelectedImage(i + 3);
                        // set which tab is selected
                        setValue(1);
                      }}
                    >
                      <Img
                        src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`}
                        alt={img.media_datetime}
                        className={classes.img}
                        unloader={(
                          <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                        )}
                      />
                    </Button>
                  </Box>
                </Box>
              );
            }
            return (
              <Grid item xs={6} sm={3} md={3} key={uniqueId()}>
                {toshow}
              </Grid>
            );
          })}
        </Grid>
        <Grid container spacing={2}>
          <Grid item>
            <Typography className={classes.titleSub}>
              {t('แผนภาพคาดการณ์ฝนเชิงพื้นที่ จากแบบจำลองอากาศเชิงตัวเลขด้วยคอมพิวเตอร์สมรรถนะสูง (TMD-WRF) โดย กรมอุตุนิยมวิทยา')}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          {tmdrain.slice(0, 3).map((img, i) => (
            <Grid item sm={4} md={4} key={uniqueId()}>
              <Box display="block" mt={2}>
                <Box className={classes.bodyBox}>
                  <Button id={`tmd_forecast_rain_${i}`} onClick={() => { setisOpen(true); setlightIndex(i); }}>
                    <Img
                      src={img}
                      alt={t('กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา')}
                      className={classes.img}
                      unloader={(
                        <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                      )}
                    />
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={5} justifyContent="space-around">
          {tmdrain.slice(3, 7).map((img, i) => (
            <Grid item xs={6} sm={3} md={3} key={uniqueId()}>
              <Box display="block" mt={2}>
                <Box className={classes.bodyBox}>
                  <Button
                    id={`tmd_forecast_rain_${i + 3}`}
                    onClick={() => {
                      setisOpen(true);
                      setlightIndex(i + 3);
                    }}
                  >
                    <Img
                      src={img}
                      alt={t('กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา')}
                      className={classes.img}
                      unloader={(
                        <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                      )}
                    />
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 50 }}>
          <Grid item>
            <Typography variant="body2">
              *
              {' '}
              {t('โดยทั่วไปความแม่นยำของการคาดการณ์สภาวะฝนจะลดลงเมื่อระยะเวลาคาดการณ์ยาวขึ้น โดยจะมีความแม่นยำสูงสุดที่ 3 วันข้างหน้า โปรดใช้วิจารณญาณในการนำข้อมูลไปใช้')}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <Modal
        open={isModalOpen}
        size="md"
        resetModal={handleModalClose}
        modalHeader={(
          <AppBar position="static" color="inherit" className={classes.tabModal} style={{ alignItems: 'center' }}>
            <StyledTabs position="static" value={value} style={{ width: '90%' }} onChange={handleChange} scrollButtons="auto" variant="scrollable" aria-labelledby="simple tabs example" textColor="secondary" indicatorColor="secondary">
              <StyledTab icon={<PlayArrowIcon fontSize="inherit" />} label={<Box>Thailand (3km x 3km)</Box>} {...a11yProps(0)} />
              <StyledTab icon={<PlayArrowIcon fontSize="inherit" />} label={<Box>Southeast Asia (9km x 9km)</Box>} {...a11yProps(1)} />
              <StyledTab icon={<PlayArrowIcon fontSize="inherit" />} label={<Box>Asia (27km x 27km)</Box>} {...a11yProps(2)} />
              <StyledTab icon={<PlayArrowIcon fontSize="inherit" />} label={<Box>Thailand Basin (3km x 3km)</Box>} {...a11yProps(3)} />
            </StyledTabs>
          </AppBar>
        )}
        modalContent={(
          <>
            <TabPanel value={value} index={0} key={uniqueId()} style={{ width: '70%', margin: 'auto' }}>
              <div>
                <Carousel
                  selectedItem={selectedImage}
                  infiniteLoop
                  showThumbs={false}
                  renderArrowPrev={(onClickHandler, hasPrev, label) => hasPrev && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        left: 0,
                      }}
                    >
                      <NavigateBeforeIcon />
                    </Button>
                  )}
                  renderArrowNext={(onClickHandler, hasNext, label) => hasNext && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        right: 0,
                      }}
                    >
                      <NavigateNextIcon />
                    </Button>
                  )}
                >
                  {rain.map((img) => (
                    <div key={uniqueId()} style={{ width: '100%', margin: 'auto' }}>
                      <Img src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`} alt="" unloader={(<Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />)} />
                      <embed
                        type="image/svg+xml"
                        id="thailand"
                        src={Amphoe}
                        className="svg svg-content svg-transform"
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </TabPanel>
            <TabPanel value={value} index={1} key={uniqueId()} style={{ width: '70%', margin: 'auto' }}>
              <div>
                <Carousel
                  selectedItem={selectedImage}
                  infiniteLoop
                  showThumbs={false}
                  renderArrowPrev={(onClickHandler, hasPrev, label) => hasPrev && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        left: 0,
                      }}
                    >
                      <NavigateBeforeIcon />
                    </Button>
                  )}
                  renderArrowNext={(onClickHandler, hasNext, label) => hasNext && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        right: 0,
                      }}
                    >
                      <NavigateNextIcon />
                    </Button>
                  )}
                >
                  {rainsea.map((img) => (
                    <div key={uniqueId()} style={{ width: '100%', margin: 'auto' }}>
                      <Img src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`} alt="" unloader={(<Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />)} />
                      <div className="svg svg-content svg-transform">
                        <ProvinceSVG
                          width="100%"
                          viewBox="-462 -800 4000 2650"
                        />
                      </div>
                    </div>
                  ))}
                </Carousel>
              </div>
            </TabPanel>
            <TabPanel value={value} index={2} key={uniqueId()} style={{ width: '70%', margin: 'auto' }}>
              <div>
                <Carousel
                  infiniteLoop
                  showThumbs={false}
                  renderArrowPrev={(onClickHandler, hasPrev, label) => hasPrev && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        left: 0,
                      }}
                    >
                      <NavigateBeforeIcon />
                    </Button>
                  )}
                  renderArrowNext={(onClickHandler, hasNext, label) => hasNext && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        right: 0,
                      }}
                    >
                      <NavigateNextIcon />
                    </Button>
                  )}
                >
                  {rainasia.map((img) => (
                    <div key={uniqueId()} style={{ width: '100%', margin: 'auto' }}>
                      <Img src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`} alt="" unloader={(<Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />)} />
                      <div className="svg svg-content svg-transform">
                        <ProvinceSVG
                          width="97%"
                          viewBox="-1115 -1180 4800 4250"
                          className="svg svg-content svg-transform"
                        />
                      </div>
                    </div>
                  ))}
                </Carousel>
              </div>
            </TabPanel>
            <TabPanel value={value} index={3} key={uniqueId()} style={{ width: '70%', margin: 'auto' }}>
              <div>
                <Carousel
                  infiniteLoop
                  showThumbs={false}
                  renderArrowPrev={(onClickHandler, hasPrev, label) => hasPrev && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        left: 0,
                      }}
                    >
                      <NavigateBeforeIcon />
                    </Button>
                  )}
                  renderArrowNext={(onClickHandler, hasNext, label) => hasNext && (
                    <Button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        position: 'absolute',
                        zIndex: 2,
                        top: 0,
                        width: '10%',
                        height: '100%',
                        cursor: 'pointer',
                        right: 0,
                      }}
                    >
                      <NavigateNextIcon />
                    </Button>
                  )}
                >
                  {rainbasin.map((img) => (
                    <div key={uniqueId()} style={{ width: '100%', margin: 'auto' }}>
                      <Img src={`${hostApi}/shared/image?_csrf=&image=${img.media_path}`} alt="" unloader={(<Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />)} />
                      <embed
                        type="image/svg+xml"
                        id="basin"
                        src={Amphoe}
                        className="svg svg-content svg-transform"
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </TabPanel>
          </>
        )}
      />
      {
        isEmpty(tmdrain[lightIndex]) === false && isOpen && (
          <Lightbox
            mainSrc={tmdrain[lightIndex]}

            nextSrc={tmdrain[(lightIndex + 1) % tmdrain.length]}
            prevSrc={tmdrain[(lightIndex + tmdrain.length - 1) % tmdrain.length]}
            imageTitle={t('MSLP และ precipitation 24 ชม. จัดทำโดย กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา')}
            onCloseRequest={() => { setisOpen(false); setlightIndex(1); }}
            onMovePrevRequest={() => {
              setlightIndex((lightIndex + tmdrain.length - 1) % tmdrain.length);
            }}
            onMoveNextRequest={() => setlightIndex((lightIndex + 1) % tmdrain.length)}
            imagePadding={50}
            reactModalStyle={{
              overlay: { zIndex: '10000000' },
            }}
          />
        )
      }
    </>
  );
}
